import {isFabricWebview} from '~/common/utils/webview';

export const eventStepsType = {
  PREMIUM: 'premium',
  PREMIUM_ADD_GUESTS_AFTER: 'premium_add_guests_after',
  FREEMIUM: 'freemium',
  FREEMIUM_WITH_GUESTS: 'freemium_with_guests',
  FREE: 'free',
  FREE_WITH_GUESTS: 'free_with_guests',
};

export const addGuestsPreCondition = (state, preConditions = []) =>
  [
    ...preConditions,
    !state.fabricTemplate?.premium,
    state.guests?.guests?.count === 0,
    !isFabricWebview(),
  ].every(Boolean);

export const getEventStepsType = (state) => {
  const hasGuests = state.guests?.guests?.count > 0;
  const {pathname} = window.location;
  const addGuestsPreConditionsMet = addGuestsPreCondition(state);
  if (state.fabricTemplate?.premium && addGuestsPreConditionsMet) {
    return eventStepsType.PREMIUM_ADD_GUESTS_AFTER;
  }
  if (hasGuests || pathname.includes('guests')) {
    return state.details.isPremium
      ? eventStepsType.FREEMIUM_WITH_GUESTS
      : eventStepsType.FREE_WITH_GUESTS;
  }
  if (!addGuestsPreConditionsMet) {
    return eventStepsType.PREMIUM;
  }
  return state.details.isPremium ? eventStepsType.FREEMIUM : eventStepsType.FREE;
};
